import React, { useState, useEffect } from "react";
import { projectsData } from "../data/projects";
import ProjectCard from "../components/ProjectCard";

const ProjectsPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={`min-h-fit w-fit mx-auto px-2 transition-filter duration-1000 ${isLoaded ? "filter-none" : "blur-sm"}`}>
      <div className="relative">
        <div className="space-y-12 mt-32 md:mt-10">
          {[...projectsData].reverse().map((project, index) => (
            <div
              key={project._id}
              className="sticky top-0 h-auto lg:h-screen flex items-center justify-center"
              style={{ zIndex: index }}
            >
              <ProjectCard project={project} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsPage;